import { logServerHttpError } from "./serverLogger";
import type { HttpErrorInfo } from "./types";

/**
 * Logs HTTP errors on server (structured stdout) or client (Datadog browser SDK).
 * Must not statically import DatadogService to avoid breaking RSC / SSR bundles.
 */
export const logHttpError = (errorInfo: HttpErrorInfo): void => {
  if (typeof window === "undefined") {
    logServerHttpError(errorInfo);
    return;
  }

  void import("./DatadogService")
    .then((module) => {
      const logClientHttpError = module.logHttpError;
      if (typeof logClientHttpError === "function") {
        logClientHttpError(errorInfo);
        return;
      }
      logServerHttpError(errorInfo);
    })
    .catch(() => {
      logServerHttpError(errorInfo);
    });
};
